import { Component, Inject } from '@angular/core';
import {  MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAppNotificationUserEvent } from '../models/app-notification-user-event.model';
import { AppNotificationService } from '../app-notification.service';

@Component({
    selector: 'app-notification-event-preferences',
    templateUrl: './app-notification-event-preferences.component.html',
    styleUrls: ['./app-notification-event-preferences.component.scss'],
    providers: [AppNotificationService],
    standalone: false
})
export class AppNotificationEventPreferencesComponent {

    // private _userEventData: AppNotificationUserEvent;
    // private userEventData$: Subscription;
    private readonly originalData: IAppNotificationUserEvent;
    readonly eventName: string;
    data: IAppNotificationUserEvent;
    isBoxDisabled = false;
    readonly selectorCheckBoxId = 'selector-box';
    isSaveButtonVisible = true;

    constructor(public dialogRef: MatDialogRef<AppNotificationEventPreferencesComponent>,
        @Inject(MAT_DIALOG_DATA)
        public dialogData: DialogObject,
        private appNotificationService: AppNotificationService) {
        if (typeof dialogData.saveButton !== 'undefined') { this.isSaveButtonVisible = dialogData.saveButton; }
        this.data = dialogData.data;
        this.originalData = { ...dialogData.data };
        this.eventName = dialogData.eventName;
        switch (this.eventName) {
            case '$APP-LEVEL-SELECTION$':
                this.eventName = 'Your Notifications For App'
                    + this.appNotificationService.appNames[this.data.appId.toString().trim()];
                break;
            case '$MENU-LEVEL-SELECTION$':
                this.eventName = 'Your Notifications For Selected Group';
                break;
        }
        if (typeof dialogData.readonly === 'boolean' && dialogData.readonly === true) {
            this.isBoxDisabled = true;
        }
    }

    boxChanged(event: MatCheckboxChange) {
        if (event.source.id === this.selectorCheckBoxId) {
            [
                this.data.isEmailSubscribed,
                this.data.isInAppSubscribed,
                this.data.isPushSubscribed,
                this.data.isSmsSubscribed
            ] = [event.checked, event.checked, event.checked, event.checked];
        }
        // this.appNotificationService.notifyNotificationPreferencesUpdation(this.data);
    }

    save(): void {
        this.dialogRef.close({
            'data': this.data,
            'isModified': !(this.originalData === this.data)
        });
    }
}
export interface IAppNotificationEventPreferencesComponentResult {
    data: IAppNotificationUserEvent;
    isModified: boolean;
}
export interface DialogObject {
    'eventName': string, 'data': IAppNotificationUserEvent, 'readonly': boolean, 'saveButton': boolean
}

